export default "__VITE_ASSET__mj6JjxBX__"